import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Props from '@components/Props';
import Paragraph from '@components/Paragraph';
export const _frontmatter = {
  "name": "CookiesConsent",
  "menu": "Components",
  "route": "/components/cookies-consent",
  "description": "The API documentation of the CookiesConsent React component. Play around with demos and check out its props."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`CookiesConsent`}</h1>
    <p>{`This component can be one good UI solution for you when you want to handle yourself the interface between your cookies and your users.
`}<strong parentName="p">{`CookiesConsent`}</strong>{` provides a light but advanced interface to help you manage your cookies selections.`}</p>
    <p>{`On desktop screens, the description of the category will be displayed next to the title. On small screens, it will be displayed inside the content of the accordion.`}</p>
    <p>{`You can append any content to each `}<inlineCode parentName="p">{`<CookiesConsent.Category>`}</inlineCode>{`, meaning you can bring
your own table component, or a list, or even a simple paragraph. Here, the `}<inlineCode parentName="p">{`Table`}</inlineCode>{` component
is not included in `}<inlineCode parentName="p">{`<CookiesConsent>`}</inlineCode>{`, it is a separate component for the sake of the demo.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` By default, the Categories are uncontrolled. But you can also chose to control them with a `}<em parentName="p">{`[checked, onChange]`}</em>{` set of props.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/cookies-consent#"
        }}>{`CookiesConsent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/cookies-consent#cookiesconsent-category"
        }}>{`CookiesConsent.Category`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/cookies-consent#cookiesconsent-controls"
        }}>{`CookiesConsent.Controls`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/cookies-consent#cookiesconsent-button"
        }}>{`CookiesConsent.Button`}</a></li>
    </ul>
    <h2>{`Default`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [cookies, setCookies] = React.useState({
    analytics: false,
    functional: true,
    tracking: false,
  })
  const toggleAll = ({ target: { checked }}) =>
    setCookies({
      analytics: checked,
      functional: checked,
      tracking: checked,
    })
  return (
    <CookiesConsent title="Manage Cookies Preferences">
      <CookiesConsent.Category
        checked={cookies.analytics}
        description="Theses cookies help us to analyze what you are doing on our site"
        title="Analytics cookies"
        onChange={e => setCookies(cookies => ({ ...cookies, analytics: e.target.checked }))}
      >
        <Paragraph>
          This is a paragraph explaining how great are those cookies. This is a paragraph
          explaining how great are those cookies. This is a paragraph explaining how great are
          those cookies. This is a paragraph explaining how great are those cookies.
        </Paragraph>
      </CookiesConsent.Category>
      <CookiesConsent.Category
        checked={cookies.functional}
        description="Theses cookies enable us to offer you a personalized experience on our site"
        title="Functional cookies"
        onChange={e => setCookies(cookies => ({ ...cookies, functional: e.target.checked }))}
      >
        <Paragraph>
          This is a paragraph explaining how great are those cookies. This is a paragraph
          explaining how great are those cookies. This is a paragraph explaining how great are
          those cookies. This is a paragraph explaining how great are those cookies.
        </Paragraph>
      </CookiesConsent.Category>
      <CookiesConsent.Category
        checked={cookies.tracking}
        description="Theses cookies helps us to track you. You cannot escape!"
        title="Tracking cookies"
        onChange={e => setCookies(cookies => ({ ...cookies, tracking: e.target.checked }))}
      >
        <Paragraph>
          This is a paragraph explaining how great are those cookies. This is a paragraph
          explaining how great are those cookies. This is a paragraph explaining how great are
          those cookies. This is a paragraph explaining how great are those cookies.
        </Paragraph>
      </CookiesConsent.Category>
      <CookiesConsent.Controls switchLabel="All cookies" onChange={toggleAll}>
        <CookiesConsent.Button>Cancel</CookiesConsent.Button>
        <CookiesConsent.Button>Confirm</CookiesConsent.Button>
      </CookiesConsent.Controls>
    </CookiesConsent>
  )
}
`}</code></pre>
    <h2>{`Table in categories`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent title="Manage Cookies Preferences">
  <CookiesConsent.Category
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Table />
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies enable us to offer you a personalized experience on our site"
    title="Functional cookies"
  >
    <Table />
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies helps us to track you. You cannot escape!"
    title="Tracking cookies"
  >
    <Table />
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h2>{`No controls`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent title="Manage Cookies Preferences">
  <CookiesConsent.Category
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies enable us to offer you a personalized experience on our site"
    title="Functional cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies helps us to track you. You cannot escape!"
    title="Tracking cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h2>{`No title`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent>
  <CookiesConsent.Category
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies enable us to offer you a personalized experience on our site"
    title="Functional cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
  <CookiesConsent.Category
    description="Theses cookies helps us to track you. You cannot escape!"
    title="Tracking cookies"
  >
    <Paragraph>
      This is a paragraph explaining how great are those cookies. This is a paragraph
      explaining how great are those cookies. This is a paragraph explaining how great are
      those cookies. This is a paragraph explaining how great are those cookies.
    </Paragraph>
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h2>{`Extended`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedCookiesConsent title="Manage Cookies Preferences">
  <ExtendedCategory
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Table />
  </ExtendedCategory>
  <ExtendedCategory
    description="Theses cookies enable us to offer you a personalized experience on our site"
    title="Functional cookies"
  >
    <Table />
  </ExtendedCategory>
  <ExtendedCategory
    description="Theses cookies helps us to track you. You cannot escape!"
    title="Tracking cookies"
  >
    <Table />
  </ExtendedCategory>
</ExtendedCookiesConsent>
`}</code></pre>
    <h2>{`Props`}</h2>
    <Props of="CookiesConsent" mdxType="Props" />
    <br />
    <hr />
    <h2>{`CookiesConsent.Category`}</h2>
    <h3>{`Default Category`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent>
  <CookiesConsent.Category
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Paragraph>
      This is a paragprah about the category. This is a paragprah about the category. This is a
      paragprah about the category.
    </Paragraph>
    <Paragraph>
      This is a paragprah about the category. This is a paragprah about the category. This is a
      paragprah about the category.
    </Paragraph>
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h3>{`Table in content`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent>
  <CookiesConsent.Category
    description="Theses cookies help us to analyze what you are doing on our site"
    title="Analytics cookies"
  >
    <Table />
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h3>{`No description`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent>
  <CookiesConsent.Category title="Analytics cookies">
    <Paragraph>
      This is a paragprah about the category. This is a paragprah about the category. This is a
      paragprah about the category.
    </Paragraph>
  </CookiesConsent.Category>
</CookiesConsent>
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedCategory
  description="Theses cookies help us to analyze what you are doing on our site"
  title="Analytics cookies"
>
  <Paragraph>
    This is a paragprah about the category. This is a paragprah about the category. This is a
    paragprah about the category.
  </Paragraph>
</ExtendedCategory>
`}</code></pre>
    <h3>{`Props`}</h3>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Accordion>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/accordion/"
      }}>{`Api`}</a>{`.`}</p>
    <Props of="CookiesConsent.Category" mdxType="Props" />
    <br />
    <hr />
    <h2>{`CookiesConsent.Controls`}</h2>
    <h3>{`Default Controls`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [isOn, setIsOn] = React.useState(false)
  return (
    <CookiesConsent>
      <CookiesConsent.Controls checked={isOn} onChange={(e) => setIsOn(e.target.checked)} switchLabel="All cookies">
        <CookiesConsent.Button>Cancel</CookiesConsent.Button>
        <CookiesConsent.Button>Confirm</CookiesConsent.Button>
      </CookiesConsent.Controls>
    </CookiesConsent>
  )
}
`}</code></pre>
    <h3>{`No switch`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent>
  <CookiesConsent.Controls>
    <CookiesConsent.Button>Cancel</CookiesConsent.Button>
    <CookiesConsent.Button>Confirm</CookiesConsent.Button>
  </CookiesConsent.Controls>
</CookiesConsent>
`}</code></pre>
    <h3>{`Custom controls`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [isOn, setIsOn] = React.useState(false)
  return (
    <CookiesConsent>
      <CookiesConsent.Controls checked={isOn} onChange={(e) => setIsOn(e.target.checked)} switchLabel="All cookies">
        <button>Cancel</button>
        <button>Confirm</button>
      </CookiesConsent.Controls>
    </CookiesConsent>
  )
}
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
  <ExtendedControlsStory />
`}</code></pre>
    <h3>{`Props`}</h3>
    <Props of="CookiesConsent.Controls" mdxType="Props" />
    <br />
    <hr />
    <h2>{`CookiesConsent.Button`}</h2>
    <h3>{`Default Button`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<CookiesConsent.Button>Confirm</CookiesConsent.Button>
`}</code></pre>
    <h3>{`Props`}</h3>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Button>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/button/"
      }}>{`Api`}</a>{`.
It requires no other prop.`}</p>
    <Props of='CookiesConsent.Button' mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      